import { render, staticRenderFns } from "./AllApplicants.vue?vue&type=template&id=51a5c0a8&"
import script from "./AllApplicants.vue?vue&type=script&lang=js&"
export * from "./AllApplicants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports